import React, { useState, useEffect } from "react";
import { Box, Typography, CircularProgress } from "@mui/material";
import MapView from "./MapView_m";
import { useSearchParams } from "react-router-dom";
import { socketWex, setSocketsAgent } from "../../../utils/Socket";
import useMaps from "../../../hooks/useMaps";

export default function VisitScreen() {
  const [searchParams] = useSearchParams();
  const idOut = searchParams.get("idOut");
  const [loading, setLoading] = useState(true);
  //
  const [dataAdjuster, setDataAdjuster] = useState(null);
  //
  const [adjusterLocation, setAdjusterLocation] = useState(null);
  const [incidentLocation, setIncidentLocation] = useState(null);
  const [routeCoordinates, setRouteCoordinates] = useState([]);

  const { getRouteByPoints } = useMaps();

  useEffect(() => {
    // 🔴 NO hay agente → socket desconectado
    if (!idOut) {
      if (socketWex.connected) {
        socketWex.disconnect();
      }
      return;
    }
    // 🟢 Hay agente → auth + connect
    setSocketsAgent(idOut);
    if (!socketWex.connected) {
      socketWex.connect();
    }
    return () => {
      socketWex.off();
    };
  }, [idOut]);

  useEffect(() => {
    if (!idOut) {
      setLoading(false);
      alert("ID de visita no proporcionado.");
      return;
    }

    const handleLocationAgent = (data) => {
      if (!data?.newLocation) return;

      const [lat, lng] = data.newLocation
        .split(",")
        .map((coord) => parseFloat(coord.trim()));

      if (isNaN(lat) || isNaN(lng)) return;

      setAdjusterLocation({ lat, lng });
    };

    const handleIncidentFinish = (data) => {
      console.log("Incident Finish", data);
      alert("El incidente ha sido finalizado");
      /* si success es false el evento (incidente) finalizo  */
    };
    const handleDataIncident = (data) => {
      console.log("adjusters-client-data-incident", data);

      setDataAdjuster(data.dataAdjuster);

      // 1️⃣ Primera ubicación del ajustador (IMPORTANTE)
      if (data?.location) {
        const [lat, lng] = data.location
          .split(",")
          .map((coord) => parseFloat(coord.trim()));

        if (!isNaN(lat) && !isNaN(lng)) {
          setAdjusterLocation({ lat, lng });
        }
      }

      // 2️⃣ Ubicación del incidente
      if (!data?.ubicationIncident) return;

      const [lat, lng] = data.ubicationIncident
        .split(",")
        .map((coord) => parseFloat(coord.trim()));

      if (isNaN(lat) || isNaN(lng)) return;

      setIncidentLocation({ lat, lng });
    };

    const handlerConnect = () => {
      socketWex.emit("adjusters-client-connect", { idOutbound: idOut });
      console.log("EMIT: adjusters-client-connect", idOut);
    };

    socketWex.on("connect", handlerConnect);
    socketWex.on("adjusters-client-finished", handleIncidentFinish); // Agrega el listener para el evento de finalización de la visita
    socketWex.on("adjusters-client-data-incident", handleDataIncident); // ubicacion del incidente
    socketWex.on("update-location", handleLocationAgent); // ubicacion del agente

    setLoading(false);
    return () => {
      socketWex.off("update-location", handleLocationAgent);
      socketWex.off("adjusters-client-finished", handleIncidentFinish);
      socketWex.off("adjusters-client-data-incident", handleDataIncident);
    };
  }, [idOut]);

  useEffect(() => {
    if (!adjusterLocation || !incidentLocation) return;

    const fetchRoute = async () => {
      try {
        const response = await getRouteByPoints({
          lng_origen: adjusterLocation.lng,
          lat_origen: adjusterLocation.lat,
          lng_destino: incidentLocation.lng,
          lat_destino: incidentLocation.lat,
        });

        if (response && response.routes && response.routes.length > 0) {
          const route = response.routes[0];
          // Las coordenadas de OSRM vienen como [lng, lat]
          const coordinates = route.geometry.coordinates.map((coord) => ({
            lat: coord[1],
            lng: coord[0],
          }));
          setRouteCoordinates(coordinates);
        }
      } catch (error) {
        console.error("Error al obtener la ruta de OSRM:", error);
      }
    };

    fetchRoute();
  }, [adjusterLocation, incidentLocation]);

  if (loading) {
    return (
      <Box
        sx={{
          height: "100vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "#fff",
          gap: 2,
        }}
      >
        <CircularProgress size={55} thickness={4} />
        <Typography variant="body1" sx={{ color: "#555" }}>
          Cargando visita...
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        width: "100%",
        height: "100vh",
        maxWidth: 450,
        mx: "auto",
        bgcolor: "#fff",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      {/* Mapa */}
      <Box sx={{ flex: 1 }}>
        {incidentLocation && adjusterLocation ? (
          <MapView
            technicianLocation={adjusterLocation}
            incidentLocation={incidentLocation}
            dataAdjuster={dataAdjuster}
            routeCoordinates={routeCoordinates}
          />
        ) : (
          <Typography align="center" sx={{ mt: 4 }}>
            Cargando ubicación del incidente...
          </Typography>
        )}
      </Box>

      {/* Información de estado del agente */}
      <Box
        sx={{
          p: 2,
          bgcolor: "background.paper",
          borderTopLeftRadius: 20,
          borderTopRightRadius: 20,
          mt: -3,
          position: "relative",
          zIndex: 2,
          textAlign: "center",
        }}
      >
        <Typography
          variant="subtitle1"
          sx={{
            fontFamily: "Raleway, sans-serif",
            color: "#666",
            fontWeight: 500,
          }}
        >
          {adjusterLocation
            ? "Agente en camino"
            : "Esperando ubicación del agente..."}
        </Typography>
      </Box>
    </Box>
  );
}
